function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                        "VariableDeclarator": true  } }] */
import Accordion from '@engine/components/presentational/base/accordion';
import Chip from '@engine/components/presentational/base/chip';
import Error from '@engine/components/presentational/base/error';
import PanelStatus from '@engine/components/presentational/base/panel-status';
import React from 'react';
import { connect } from 'react-redux';
import { updateWpfAllowedDomains } from '@engine/actions/creators/wpf-allowed-domains';
var STATUS_MESSAGE_EXIT_DELAY = 5000;
var COMMA_KEY_ASCII = 188;
var ENTER_KEY_ASCII = 13;
var INPUT_KEY_CODES = [COMMA_KEY_ASCII, ENTER_KEY_ASCII];

var WpfAllowedDomains = /*#__PURE__*/function (_React$Component) {
  _inherits(WpfAllowedDomains, _React$Component);

  var _super = _createSuper(WpfAllowedDomains);

  function WpfAllowedDomains(props) {
    var _this;

    _classCallCheck(this, WpfAllowedDomains);

    _this = _super.call(this, props);

    _this.renderError = function (message) {
      return React.createElement(Error, {
        className: "alert-slim"
      }, message, _this.renderValidationErrors());
    };

    _this.renderForm = function () {
      var _this$state = _this.state,
          allowedDomains = _this$state.allowedDomains,
          currentInput = _this$state.currentInput;
      return React.createElement("div", {
        className: "form-group"
      }, React.createElement("label", null, _this.locales.label), React.createElement("div", {
        className: "alert alert-info-light"
      }, React.createElement("p", null, _this.locales.tipsTitle), React.createElement("ul", null, React.createElement("li", null, _this.locales.separateDomainsTip), React.createElement("li", null, _this.locales.includeHttpTip))), React.createElement("input", {
        type: "text",
        value: currentInput,
        onChange: _this.handleInputChange,
        onKeyDown: _this.handleKeyDown,
        className: "form-control"
      }), React.createElement("div", {
        className: "mt-5"
      }, allowedDomains.map(function (domain) {
        return React.createElement(Chip, {
          key: domain,
          label: domain,
          onClick: function onClick() {
            return _this.removeDomain(domain);
          }
        });
      })));
    };

    _this.handleInputChange = function (e) {
      _this.setState({
        currentInput: e.target.value
      });
    };

    _this.handleKeyDown = function (e) {
      if (INPUT_KEY_CODES.includes(e.keyCode)) {
        e.preventDefault();

        _this.addDomain();
      }
    };

    _this.addDomain = function () {
      var _this$state2 = _this.state,
          currentInput = _this$state2.currentInput,
          allowedDomains = _this$state2.allowedDomains;
      var trimmedInput = currentInput.trim();

      if (!trimmedInput || allowedDomains.includes(trimmedInput)) {
        return;
      }

      var updatedDomains = [].concat(_toConsumableArray(allowedDomains), [trimmedInput]);

      _this.setState({
        allowedDomains: updatedDomains,
        currentInput: ''
      });

      _this.updateAllowedDomains(updatedDomains);
    };

    _this.removeDomain = function (domain) {
      var updatedDomains = _this.state.allowedDomains.filter(function (prevDomain) {
        return prevDomain !== domain;
      });

      _this.setState({
        allowedDomains: updatedDomains
      });

      _this.updateAllowedDomains(updatedDomains);
    };

    _this.updateAllowedDomains = function (updatedDomains) {
      _this.setState({
        showSuccessfulStatus: false
      });

      var domainsString = updatedDomains.join(',');

      _this.props.updateWpfAllowedDomains(_this.props.url, domainsString);
    };

    _this.clearSuccessfulStatus = function () {
      if (_this.statusMessageTimeout) {
        return;
      }

      _this.setState({
        showSuccessfulStatus: true
      });

      _this.statusMessageTimeout = setTimeout(function () {
        _this.setState({
          showSuccessfulStatus: false
        });

        _this.statusMessageTimeout = null;
      }, STATUS_MESSAGE_EXIT_DELAY);
    };

    _this.renderValidationErrors = function () {
      var errors = _this.props.errors;

      if (!Array.isArray(errors) || errors.length === 0) {
        return null;
      }

      return React.createElement("div", null, React.createElement("br", null), errors[1]);
    };

    _this.state = {
      showSuccessfulStatus: false,
      allowedDomains: props.initialDomains,
      currentInput: ''
    };
    _this.statusMessageTimeout = null; // Locales

    _this.locales = {
      title: I18n.t('javascript.merchants.form.embed_access'),
      label: I18n.t('javascript.merchants.form.allowed_domains'),
      tipsTitle: I18n.t('javascript.common.tips'),
      separateDomainsTip: I18n.t('javascript.merchants.form.separate_domains_using_comma'),
      includeHttpTip: I18n.t('javascript.merchants.form.include_http_or_https'),
      errorMessage: I18n.t('javascript.errors.something_went_wrong')
    };
    return _this;
  }
  /**
   * Component life cycle
   */


  _createClass(WpfAllowedDomains, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isSaved !== this.props.isSaved) {
        this.clearSuccessfulStatus();
      }
    }
    /**
     * Render component
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          hasError = _this$props.hasError,
          isSaved = _this$props.isSaved,
          isSaving = _this$props.isSaving,
          message = _this$props.message;
      var showSuccessfulStatus = this.state.showSuccessfulStatus;
      return React.createElement(Accordion, {
        icon: "user",
        title: this.locales.title,
        header: React.createElement(PanelStatus, {
          hasError: hasError,
          isSaved: isSaved,
          isSaving: isSaving,
          showSuccessfulStatus: showSuccessfulStatus
        })
      }, hasError && this.renderError(message), this.renderForm());
    }
    /**
     * Methods
     */

  }]);

  return WpfAllowedDomains;
}(React.Component);
/**
 * PropTypes Validation
 */


export default connect(function (state) {
  return {
    errors: state.wpfAllowedDomains.errors,
    hasError: state.wpfAllowedDomains.hasError,
    isSaved: state.wpfAllowedDomains.isSaved,
    isSaving: state.wpfAllowedDomains.isSaving,
    message: state.wpfAllowedDomains.message
  };
}, {
  updateWpfAllowedDomains: updateWpfAllowedDomains
})(WpfAllowedDomains);